const React = require('react');
const { createElement: h, useEffect, useRef, useState } = React;
const ReactDOM = require('react-dom');
const { streamChatWorkflowPlan } = require('../lib/workflowStorage');
const { CodingLines } = require('./CodingLines');
const NodeIcon = require('./NodeIcon');
// Shared chat-rendering helpers (also used by the AI Flow Builder balloon).
const { formatText, stripStreamingXml, parseAiMessage, isPrematureStop, hasQuestionPartAfter, QuestionTabs, selectionText } = require('../lib/plannerChatFormat');
// OAuth connect flow (for the "Connect <Provider>" button when a probe fails
// because a login() service isn't connected yet).
const { connectProvider, verifyProviderConnected, providerLabel, PROVIDER_LABELS } = require('../lib/oauthConnect');
const { streamWorkflowHelperChat } = require('../lib/workflowHelper');
const { request } = require('../lib/apiClient');
const { translateText } = require('../lib/language');

function formatTokenCount(n) {
  if (!n || n <= 0) return '0';
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'k';
  return String(n);
}

// Provider brand logos for the "Connect or manage accounts" panel. Mirrors the
// SVGs on ConnectedAccountsPage so the panel reads as the same feature.
function ProviderLogo(props) {
  var provider = props.provider;
  if (provider === 'google') {
    return h('svg', { className: 'planner-services-logo', width: 16, height: 16, viewBox: '0 0 24 24' },
      h('path', { d: 'M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z', fill: '#4285F4' }),
      h('path', { d: 'M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z', fill: '#34A853' }),
      h('path', { d: 'M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z', fill: '#FBBC05' }),
      h('path', { d: 'M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z', fill: '#EA4335' })
    );
  }
  if (provider === 'microsoft') {
    return h('svg', { className: 'planner-services-logo', width: 16, height: 16, viewBox: '0 0 24 24' },
      h('rect', { x: 1, y: 1, width: 10.5, height: 10.5, fill: '#F25022' }),
      h('rect', { x: 12.5, y: 1, width: 10.5, height: 10.5, fill: '#7FBA00' }),
      h('rect', { x: 1, y: 12.5, width: 10.5, height: 10.5, fill: '#00A4EF' }),
      h('rect', { x: 12.5, y: 12.5, width: 10.5, height: 10.5, fill: '#FFB900' })
    );
  }
  if (provider === 'shopify') {
    return h('svg', { width: 21, height: 21, viewBox: '0 0 24 24' },
      h('path', { d: 'M5.1 6.7 6.5 4.9c.5-.1 1-.2 1.5-.3C8.4 2 9.7.5 11.4.5c1.9 0 2.8 1.8 3.1 3.2l2.4.7c.2.1.3.2.3.4L19 20.9 7 23.5 4.3 7.2c0-.2.2-.4.4-.4l.4-.1Z', fill: '#95BF47' }),
      h('path', { d: 'M14.8 8.1c-.5-.3-1.2-.4-1.8-.4-1.5 0-1.6.9-1.6 1.1 0 1.2 3.2 1.7 3.2 4.6 0 2.3-1.4 3.8-3.4 3.8-2.3 0-3.5-1.5-3.5-1.5l.6-2.1s1.2 1.1 2.3 1.1c.7 0 1-.6 1-.9 0-1.6-2.6-1.7-2.6-4.3 0-2.2 1.6-4.4 4.9-4.4 1.3 0 1.9.4 1.9.4l-1 2.6Z', fill: '#fff' })
    );
  }
  if (provider === 'slack') {
    return h('svg', { className: 'planner-services-logo', width: 16, height: 16, viewBox: '0 0 24 24' },
      h('path', { d: 'M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313z', fill: '#E01E5A' }),
      h('path', { d: 'M8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312z', fill: '#36C5F0' }),
      h('path', { d: 'M18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312z', fill: '#2EB67D' }),
      h('path', { d: 'M15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z', fill: '#ECB22E' })
    );
  }
  if (provider === 'atlassian') {
    return h('svg', { className: 'planner-services-logo', width: 16, height: 16, viewBox: '0 0 24 24' },
      h('defs', null,
        h('linearGradient', { id: 'planner-atl-grad', x1: '50%', y1: '100%', x2: '50%', y2: '0%' },
          h('stop', { offset: '0%', stopColor: '#0052CC' }),
          h('stop', { offset: '100%', stopColor: '#2684FF' })
        )
      ),
      h('path', { d: 'M6.65 11.13c-.21-.22-.55-.21-.71.05L.1 22.83a.5.5 0 0 0 .45.72h8.06c.26 0 .49-.15.6-.39 1.74-3.59.69-9.05-2.56-12.03z', fill: 'url(#planner-atl-grad)' }),
      h('path', { d: 'M11.53.27a11.4 11.4 0 0 0-.66 11.27l3.93 7.86c.11.23.34.38.6.38h8.06a.5.5 0 0 0 .45-.72S12.93.79 12.65.28c-.16-.27-.51-.27-.67-.01z', fill: '#2684FF' })
    );
  }
  if (provider === 'uniconta') {
    // Uniconta has no inline SVG mark; use the brand logo image, like
    // ConnectedAccountsPage does.
    return h('img', {
      className: 'planner-services-logo',
      width: 16,
      height: 16,
      alt: 'Uniconta',
      src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRi-q_UrOZBwjkxw1RsPN3-JwZocT7X_NEaXOE7hfw6yw&s=10'
    });
  }
  return null;
}

var INITIAL_MESSAGE = {
  role: 'assistant',
  content: "Describe what you want to happen. Mention the apps or information involved if you know them — I'll ask only for anything essential."
};

// Helper-mode hero example chips — clicking one sends it as the user's first
// message (replaces the old hardcoded greeting bubble).
var HELPER_EXAMPLES = ['Chasing unpaid invoices', 'Sorting customer requests', 'Copying data between systems', 'Preparing weekly updates'];


var STEP_TYPE_LABELS = {
  start: 'Start Node',
  variable: 'Variable',
  variables: 'Variable',
  condition: 'Condition',
  'set-variable': 'Set Variable',
  'console-log': 'Console Log',
  agent: 'AI',
  classifier: 'Classifier (AI)',
  'file-preview': 'File Preview',
  'computer-use': 'Computer Use',
  custom: 'Custom Node'
};

function PlanStepItem(props) {
  var step = props.step;
  var index = props.index;
  var isBuilding = props.isBuilding;
  var isDone = props.isDone;
  var phase = props.phase || '';

  var icon = null;
  if (isDone) {
    icon = h('span', { className: 'planner-step-icon planner-step-icon-done' },
      h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5 },
        h('polyline', { points: '20 6 9 17 4 12' })
      )
    );
  } else if (isBuilding) {
    icon = h('span', { className: 'planner-step-icon planner-step-icon-building' },
      h('span', { className: 'planner-step-spinner' })
    );
  } else {
    icon = h('span', { className: 'planner-step-icon planner-step-icon-pending' }, String(index + 1));
  }

  var phaseLabel = null;
  if (isBuilding && phase) {
    phaseLabel = h('span', { className: 'planner-step-phase' },
      phase === 'running' ? 'Running...' : phase === 'coding' ? 'Coding...' : phase === 'building' ? 'Building...' : ''
    );
  }

  return h('div', { className: 'planner-step-item' + (isBuilding ? ' planner-step-item-active' : '') + (isDone ? ' planner-step-item-done' : '') },
    icon,
    h('div', { className: 'planner-step-info' },
      h('div', { className: 'planner-step-type' },
        STEP_TYPE_LABELS[step.type] || 'Node',
        phaseLabel
      ),
      h('div', { className: 'planner-step-desc' },
        step.description || step.title || (step.type === 'variable' || step.type === 'variables' ? (step.label || step.key || '') : (step.prompt || ''))
      )
    )
  );
}

function WorkflowPlannerModal(props) {
  var onClose = props.onClose || function() {};
  var onBuildWorkflow = props.onBuildWorkflow || function() {};
  var plannerContext = props.plannerContext || null;
  var onFixNode = props.onFixNode || null;

  var [messages, setMessages] = useState([INITIAL_MESSAGE]);
  var [input, setInput] = useState('');
  var [loading, setLoading] = useState(false);
  var [error, setError] = useState('');
  var [plan, setPlan] = useState(null);
  var [buildStep, setBuildStep] = useState(-1);
  var [buildPhase, setBuildPhase] = useState('');
  var [buildError, setBuildError] = useState('');
  var [buildDone, setBuildDone] = useState(false);
  var [buildPaused, setBuildPaused] = useState(false);
  var [minimized, setMinimized] = useState(false);
  var [failedNodeId, setFailedNodeId] = useState(null);
  var [probing, setProbing] = useState(false);
  var [probeLabels, setProbeLabels] = useState([]);
  var [templateCheck, setTemplateCheck] = useState(null);
  var [streamingText, setStreamingText] = useState('');
  var [thinkingStatus, setThinkingStatus] = useState('');
  var [probeEvents, setProbeEvents] = useState([]);
  // A login() service a probe needs connected (e.g. 'slack'), or null. Persists
  // past the turn so the Connect button stays clickable after the stream ends.
  var [connectNeeded, setConnectNeeded] = useState(null);
  // Provider awaiting an auto-retry once the current stream finishes.
  var [pendingRetry, setPendingRetry] = useState(null);
  // Set when a turn stopped prematurely and an auto "continue" is queued for the
  // next idle render (see the premature-stop guard in doSend's done handler).
  var [pendingAutoContinue, setPendingAutoContinue] = useState(false);
  // "Connect / manage accounts" inline panel (above the input). Lets the user
  // connect Google/Microsoft/Slack/Atlassian/Uniconta up front, manage (disconnect) them,
  // and pick a DEFAULT account per provider that the planner uses for probing
  // AND pins onto the OAuth nodes it generates.
  //   servicesOpen      — panel toggle
  //   serviceConnecting — provider key whose OAuth popup is in flight (spinner)
  //   accounts          — { google:[{id,label,connectedAt}], microsoft:[...], ... }
  //   accountsLoading   — true while GET /connected-accounts is in flight
  //   removingId        — credential id currently being disconnected
  //   plannerCredIds    — { provider -> chosen credential id }. Persisted so the
  //                       choice survives reopening the modal. '' / absent means
  //                       "use the first connected account" (today's default).
  var [servicesOpen, setServicesOpen] = useState(false);
  var [serviceConnecting, setServiceConnecting] = useState(null);
  var [accounts, setAccounts] = useState({ google: [], microsoft: [], shopify: [], slack: [], atlassian: [], uniconta: [] });
  var [accountsLoading, setAccountsLoading] = useState(false);
  var [removingId, setRemovingId] = useState('');
  var [plannerCredIds, setPlannerCredIds] = useState(function() {
    try {
      var saved = window.localStorage.getItem('plannerCredentialIds');
      var parsed = saved ? JSON.parse(saved) : {};
      return (parsed && typeof parsed === 'object') ? parsed : {};
    } catch (e) { return {}; }
  });
  // Nodes the planner reused from node-memory (Pinecone) — shown as overlapping
  // logo avatars. Each: { title, icon, logoUrl, score }.
  var [similarNodesUsed, setSimilarNodesUsed] = useState([]);
  var [generatingWorkflow, setGeneratingWorkflow] = useState(false);
  var [templateExpanded, setTemplateExpanded] = useState(true);
  var [tokenUsage, setTokenUsage] = useState(null);
  // The signed-in user's plan gates the tiers: Smartest is max/enterprise only,
  // and pro-and-above default to Balanced (free defaults to Fast).
  var [userPlan, setUserPlan] = useState(null);
  var canUseSmartest = userPlan === 'max' || userPlan === 'enterprise';
  var [plannerMode, setPlannerMode] = useState(function() {
    try {
      var saved = window.localStorage.getItem('plannerMode');
      if (saved === 'fast' || saved === 'balance' || saved === 'smartest') return saved;
    } catch (e) {}
    return 'balance';
  });

  // Fetch the plan once, then apply the plan-based default + clamp Smartest.
  useEffect(function() {
    request('/auth/me').then(function(res) {
      var plan = (res && res.user && res.user.plan) ? String(res.user.plan) : 'free';
      setUserPlan(plan);
      var allowSmartest = plan === 'max' || plan === 'enterprise';
      var proPlus = plan === 'pro' || plan === 'max' || plan === 'enterprise';
      var saved = null;
      try { saved = window.localStorage.getItem('plannerMode'); } catch (e) {}
      var hasSaved = saved === 'fast' || saved === 'balance' || saved === 'smartest';
      setPlannerMode(function() {
        // No saved preference → plan default (Balanced for pro+, Fast otherwise).
        if (!hasSaved) return proPlus ? 'balance' : 'fast';
        // Saved 'smartest' but not entitled → clamp down to Balanced.
        if (saved === 'smartest' && !allowSmartest) return 'balance';
        return saved;
      });
    }).catch(function() {});
  }, []);

  function togglePlannerMode() {
    // Cycle the tiers the plan allows: Smartest only for max/enterprise.
    var order = canUseSmartest ? ['fast', 'balance', 'smartest'] : ['fast', 'balance'];
    var idx = order.indexOf(plannerMode);
    var next = order[(idx + 1) % order.length];
    setPlannerMode(next);
    try { window.localStorage.setItem('plannerMode', next); } catch (e) {}
  }
  // Guided helper — a separate Haiku-driven Q&A conversation for non-technical
  // users who struggle to describe what to automate. Toggled on,
  // the chat surface switches to the helper conversation (helperMessages); it
  // ends with selectable workflow suggestions, and picking one flips back to
  // planner mode and auto-sends that suggestion's planner-ready prompt.
  var [helperMode, setHelperMode] = useState(false);
  var [helperMessages, setHelperMessages] = useState([]);
  var [advancedOpen, setAdvancedOpen] = useState(false);

  var PLANNER_MODE_LABELS = { fast: 'Fast', balance: 'Balanced', smartest: 'Smartest' };
  var PLANNER_MODE_TITLES = {
    fast: 'Fast — lowest cost, good for simple tasks. Click to switch to Balanced.',
    balance: canUseSmartest
      ? 'Balanced — best mix of cost and quality. Click to switch to Smartest.'
      : 'Balanced — best mix of cost and quality. Click to switch to Fast.',
    smartest: 'Smartest — highest quality, higher cost. Click to switch to Fast.'
  };

  // Per-question selections: { questionIndex: selectedAnswer }
  var [selections, setSelections] = useState({});
  // Which question has "Other" input open
  var [otherOpen, setOtherOpen] = useState(null);
  var [otherText, setOtherText] = useState('');

  var chatSessionIdRef = useRef(Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8));
  var messagesEndRef = useRef(null);
  var inputRef = useRef(null);
  var buildResumeRef = useRef(null);
  var abortStreamRef = useRef(null);
  // A reviewed preview uses one user-facing action. The backend still generates
  // the concrete plan first; this flag continues into the existing canvas build.
  var buildAfterGenerationRef = useRef(false);
  // Auto-continue guard: if a discovery turn stops without asking a question and
  // without a terminal signal, we auto-send "continue" so it doesn't stall on an
  // outline. Capped so a model that keeps stopping can't loop forever; the count
  // resets whenever the USER sends a real message (see doSend's isAuto flag).
  var autoContinueCountRef = useRef(0);
  var MAX_AUTO_CONTINUE = 3;
  // Set when a probe THIS turn failed for a missing connection. The connectNeeded
  // state isn't readable inside the long-lived stream closure (it captures the
  // value at send time), so this ref lets the done-handler skip auto-continue
  // when the user must connect an account first.
  var turnNeedsConnectRef = useRef(false);
  var isBuilding = buildStep >= 0 && !buildDone && !buildError && !buildPaused;

  useEffect(function() {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, helperMessages, selections, streamingText, probeEvents]);

  useEffect(function() {
    if (!loading && !isBuilding && inputRef.current) {
      inputRef.current.focus();
    }
  }, [loading, isBuilding]);

  useEffect(function() {
    function onKey(e) {
      if (e.key === 'Escape' && !isBuilding && !minimized) onClose();
    }
    document.addEventListener('keydown', onKey);
    return function() { document.removeEventListener('keydown', onKey); };
  }, [onClose, isBuilding, minimized]);

  function resetBuildStateForReplan() {
    setBuildStep(-1);
    setBuildPhase('');
    setBuildError('');
    setBuildDone(false);
    setBuildPaused(false);
    buildResumeRef.current = null;
  }

  // Reset selections when a new AI message arrives
  function clearSelections() {
    setSelections({});
    setOtherOpen(null);
    setOtherText('');
  }

  // Route a send to whichever conversation is active. The helper and the
  // planner keep separate histories; the toggle only switches which one the
  // chat surface shows and talks to.
  function doSend(text, isAuto) {
    if (helperMode) return doSendHelper(text);
    doSendPlanner(text, isAuto);
  }

  // Send one turn of the "Suggested Workflow" helper conversation. Reuses the
  // planner's loading/streaming/error state (only one conversation is visible
  // at a time) but appends to helperMessages and never touches plan/build state.
  function doSendHelper(text) {
    if (!text || loading || isBuilding) return;

    var newUserMessage = { role: 'user', content: text };
    var nextMessages = helperMessages.concat([newUserMessage]);
    setHelperMessages(nextMessages);
    setInput('');
    setLoading(true);
    setError('');
    setStreamingText('');
    setThinkingStatus('');
    setProbeEvents([]);
    clearSelections();

    // Local-only messages (the hardcoded greeting) never ride to the server.
    var apiMessages = nextMessages.filter(function(m) { return !m.local; }).map(function(m) {
      return { role: m.role, content: m.content };
    });

    if (abortStreamRef.current) {
      abortStreamRef.current();
      abortStreamRef.current = null;
    }

    var abort = streamWorkflowHelperChat(apiMessages, {
      onEvent: function(evt) {
        if (evt.type === 'chunk') {
          setThinkingStatus('');
          setStreamingText(evt.fullText || '');
        } else if (evt.type === 'search') {
          // Helper web-search status — rendered by the shared probe-event rows.
          var searchLabel = 'Searching the web: ' + (evt.query || '');
          setProbeEvents(function(prev) {
            var next = prev.slice();
            for (var i = 0; i < next.length; i++) {
              if (next[i].label === searchLabel) {
                next[i] = { label: searchLabel, status: evt.status };
                return next;
              }
            }
            next.push({ label: searchLabel, status: evt.status });
            return next;
          });
        } else if (evt.type === 'done') {
          setHelperMessages(function(prev) {
            return prev.concat([{
              role: 'assistant',
              content: evt.rawMessage || evt.message || '',
              displayContent: evt.message || '',
              suggestions: Array.isArray(evt.suggestions) ? evt.suggestions : []
            }]);
          });
          setStreamingText('');
          setThinkingStatus('');
          setLoading(false);
          abortStreamRef.current = null;
        } else if (evt.type === 'error') {
          setLoading(false);
          setStreamingText('');
          setThinkingStatus('');
          abortStreamRef.current = null;
          setError(evt.message || 'Something went wrong. Please try again.');
        }
      },
      onError: function(err) {
        setLoading(false);
        setStreamingText('');
        setThinkingStatus('');
        abortStreamRef.current = null;
        setError(err && err.message ? err.message : 'Something went wrong. Please try again.');
      }
    });

    abortStreamRef.current = abort;
  }

  // Toggle the helper. A fresh helper conversation shows the hero empty state
  // (headline + example chips) — the Haiku Q&A only starts once the user sends
  // a first message or clicks an example.
  function toggleHelperMode() {
    if (loading || isBuilding) return;
    setHelperMode(!helperMode);
    setAdvancedOpen(false);
    setError('');
  }

  // A suggestion card was picked: leave helper mode and auto-pilot the planner
  // with that suggestion's planner-ready prompt.
  function handleSuggestionSelect(suggestion) {
    if (!suggestion || !suggestion.prompt || loading || isBuilding) return;
    setHelperMode(false);
    doSendPlanner(suggestion.prompt);
  }

  function doSendPlanner(text, isAuto) {
    if (!text || loading || isBuilding) return;

    // A real user send resets the premature-stop auto-continue budget; our own
    // injected "continue" (isAuto) must not, or the cap would never bite.
    if (!isAuto) autoContinueCountRef.current = 0;

    var newUserMessage = { role: 'user', content: text };
    var nextMessages = messages.concat([newUserMessage]);

    setMessages(nextMessages);
    setInput('');
    setLoading(true);
    setError('');
    setStreamingText('');
    setThinkingStatus('');
    setProbeEvents([]);
    setConnectNeeded(null);
    turnNeedsConnectRef.current = false;
    setSimilarNodesUsed([]);
    clearSelections();

    var apiMessages = nextMessages.filter(function(m) { return m !== INITIAL_MESSAGE; }).map(function(m) {
      return { role: m.role, content: m.content };
    });
    if (apiMessages.length === 0) apiMessages = [newUserMessage];

    // Abort any previous stream
    if (abortStreamRef.current) {
      abortStreamRef.current();
      abortStreamRef.current = null;
    }

    var abort = streamChatWorkflowPlan(apiMessages, plannerContext, {
      onEvent: function(evt) {
        if (evt.type === 'thinking') {
          setThinkingStatus(evt.text || 'Thinking...');
        } else if (evt.type === 'chunk_start') {
          setThinkingStatus('');
          setStreamingText('');
        } else if (evt.type === 'chunk') {
          setStreamingText(evt.fullText || '');
        } else if (evt.type === 'similar_nodes') {
          setSimilarNodesUsed(Array.isArray(evt.nodes) ? evt.nodes : []);
        } else if (evt.type === 'probes_start') {
          setProbing(true);
          setProbeLabels(evt.probes ? evt.probes.map(function(p) { return p.label; }) : []);
          setStreamingText('');
          setProbeEvents([]);
        } else if (evt.type === 'probe_running') {
          setProbeEvents(function(prev) {
            return prev.concat([{ label: evt.label, status: 'running', probeType: evt.probeType }]);
          });
        } else if (evt.type === 'probe_result') {
          setProbeEvents(function(prev) {
            return prev.map(function(pe) {
              if (pe.label === evt.label && pe.status === 'running') {
                return { label: evt.label, status: evt.status, probeType: evt.probeType, output: evt.output, connectProvider: evt.connectProvider };
              }
              return pe;
            });
          });
          // A login() service isn't connected — surface a persistent Connect
          // button and auto-open the accounts panel so the user can connect
          // (or confirm they already did) without hunting for the link.
          if (evt.connectProvider) {
            setConnectNeeded(evt.connectProvider);
            turnNeedsConnectRef.current = true;
            setServicesOpen(true);
          }
        } else if (evt.type === 'probes_done') {
          setProbing(false);
          setProbeLabels([]);
        } else if (evt.type === 'generating_workflow') {
          setGeneratingWorkflow(true);
        } else if (evt.type === 'token_usage') {
          setTokenUsage(evt.usage);
        } else if (evt.type === 'templateCheck') {
          setTemplateCheck(evt.data);
        } else if (evt.type === 'done') {
          // Build probe summary from accumulated probe events
          var probeSummary = '';
          if (evt.probeResults && evt.probeResults.length > 0) {
            var probeLines = evt.probeResults.map(function(pr) {
              var icon = pr.status === 'ok' ? '\u2705' : '\u274c';
              return icon + ' **' + pr.label + '** \u2014 ' + pr.status;
            });
            probeSummary = probeLines.join('\n') + '\n\n';
          }
          var displayContent = (probeSummary ? probeSummary : '') + (evt.message || '');
          var rawContent = (probeSummary ? probeSummary : '') + (evt.rawMessage || evt.message || '');
          var assistantMessage = { role: 'assistant', content: rawContent, displayContent: displayContent };
          setMessages(function(prev) { return prev.concat([assistantMessage]); });
          setStreamingText('');
          setThinkingStatus('');
          setProbeEvents([]);
          setProbing(false);
          setProbeLabels([]);
          setLoading(false);
          setGeneratingWorkflow(false);
          abortStreamRef.current = null;
          if (evt.templateCheck) {
            setTemplateCheck(evt.templateCheck);
          }
          if (evt.tokenUsage) {
            setTokenUsage(evt.tokenUsage);
          }
          if (evt.complete && evt.plan) {
            resetBuildStateForReplan();
            setPlan(evt.plan);
            setTemplateExpanded(false);
            if (buildAfterGenerationRef.current) {
              buildAfterGenerationRef.current = false;
              startBuild(evt.plan);
            }
          }

          // Premature-stop guard: the turn ended without asking anything and
          // without a terminal signal (no question / plan_preview / <ready/> /
          // generated plan) — keep discovery moving by auto-sending "continue".
          // Skipped when a Connect is needed (the user must act first) or the
          // auto-continue budget is spent (a model stuck in a stall loop).
          var stalled = !(evt.complete && evt.plan)
            && !evt.connectProvider
            && !turnNeedsConnectRef.current
            && isPrematureStop(rawContent);
          if (stalled && autoContinueCountRef.current < MAX_AUTO_CONTINUE) {
            autoContinueCountRef.current += 1;
            // Defer to an effect (like pendingRetry) so the resend runs from a
            // fresh render whose `messages` already include this assistant reply
            // — calling doSend straight from this closure would use stale state.
            setPendingAutoContinue(true);
          }
        } else if (evt.type === 'error') {
          buildAfterGenerationRef.current = false;
          setLoading(false);
          setGeneratingWorkflow(false);
          setStreamingText('');
          setThinkingStatus('');
          setProbeEvents([]);
          setProbing(false);
          abortStreamRef.current = null;
          setError(evt.message || 'Something went wrong. Please try again.');
        }
      },
      onError: function(err) {
        buildAfterGenerationRef.current = false;
        setProbing(false);
        setProbeLabels([]);
        setLoading(false);
        setStreamingText('');
        setThinkingStatus('');
        setProbeEvents([]);
        abortStreamRef.current = null;
        setError(err && err.message ? err.message : 'Something went wrong. Please try again.');
      }
    }, { mode: plannerMode, chatSessionId: chatSessionIdRef.current, plannerCredentialIds: plannerCredIds });

    abortStreamRef.current = abort;
  }

  // Auto-retry after the user connects the needed account: once the current
  // stream is idle, send a short "connected — retry" message so the planner
  // re-probes the now-connected service and continues.
  useEffect(function() {
    if (pendingRetry && !loading && !isBuilding) {
      var prov = pendingRetry;
      setPendingRetry(null);
      setConnectNeeded(null);
      doSendPlanner("I've connected my " + connectNeededLabel(prov) + " account. Please re-run the check and continue.");
    }
  }, [pendingRetry, loading, isBuilding]);

  // Auto-continue a prematurely-stopped discovery turn: once idle, resend
  // "continue". Runs from this fresh render so doSend sees up-to-date messages
  // (unlike calling it from inside the stream closure). The count is capped in
  // the done handler; this effect only fires the queued resend.
  useEffect(function() {
    if (pendingAutoContinue && !loading && !isBuilding) {
      setPendingAutoContinue(false);
      doSendPlanner('continue', true);
    }
  }, [pendingAutoContinue, loading, isBuilding]);

  // Display label for a connect-needed provider. providerLabel() covers the
  // OAuth providers; non-OAuth ones (uniconta) fall back to the raw key, so
  // capitalize it for display.
  function connectNeededLabel(provider) {
    var l = providerLabel(provider);
    return l.charAt(0).toUpperCase() + l.slice(1);
  }

  // "I've already connected — retry": the user connected the account outside
  // this panel (e.g. Uniconta on the Accounts page, or in another tab), so
  // queue the same auto-retry message the OAuth flow uses. The probe itself is
  // the verification — if the account still isn't connected it fails again.
  function handleAlreadyConnectedRetry() {
    if (!connectNeeded || pendingRetry) return;
    setError('');
    setPendingRetry(connectNeeded);
  }

  // Open the OAuth popup for a needed login() service. On success, VERIFY the
  // account actually persisted server-side before queuing the auto-retry — the
  // popup's success message alone doesn't guarantee a saved token, and retrying
  // without a real connection just re-fails the probe with a confusing loop.
  function handleConnectClick(provider) {
    setError('');
    connectProvider(provider).then(function() {
      return verifyProviderConnected(provider).then(function(connected) {
        if (connected) {
          // Refresh + reconcile the panel first so the retry probes with the
          // fresh credential id, not a stale pin to a deleted account.
          loadAccounts().then(function() { setPendingRetry(provider); });
        } else {
          // Popup closed/blocked or the flow didn't finish — say so plainly and
          // leave the Connect button instead of re-probing a still-missing account.
          setError(providerLabel(provider) + ' didn\'t finish connecting. Please click Connect again and complete the popup (make sure it isn\'t blocked).');
        }
      });
    }).catch(function() {
      // Cancelled or failed — leave the Connect button so the user can try again.
    });
  }

  // Best display name for one connected credential (email / workspace / etc.).
  function accountDisplayName(provider, cred) {
    if (!cred) return providerLabel(provider) + ' account';
    if (cred.label) return cred.label;
    var a = cred.account || {};
    return a.email || a.username || a.teamName || a.userName || a.shop || a.name
      || (providerLabel(provider) + ' account');
  }

  // Load the user's connected accounts so the panel mirrors the Accounts page.
  // Returns the request promise so callers (e.g. the post-connect auto-retry)
  // can wait for the refreshed + reconciled account list before re-probing.
  function loadAccounts() {
    setAccountsLoading(true);
    return request('/connected-accounts')
      .then(function(result) {
        var acc = (result && result.accounts) || {};
        var next = {
          google: Array.isArray(acc.google) ? acc.google : [],
          microsoft: Array.isArray(acc.microsoft) ? acc.microsoft : [],
          shopify: Array.isArray(acc.shopify) ? acc.shopify : [],
          slack: Array.isArray(acc.slack) ? acc.slack : [],
          atlassian: Array.isArray(acc.atlassian) ? acc.atlassian : [],
          uniconta: Array.isArray(acc.uniconta) ? acc.uniconta : []
        };
        setAccounts(next);
        reconcilePlannerDefaults(next);
      })
      .catch(function() { /* leave whatever we had; panel still works for connect */ })
      .then(function() { setAccountsLoading(false); });
  }

  // Keep the persisted planner-default ids in sync with the accounts that
  // actually exist: a pin to a deleted credential is replaced by the first
  // account (probing with a stale id fails with "account no longer exists"),
  // and a provider with accounts but no selection gets the first one pinned
  // so a fresh connect is picked up automatically.
  function reconcilePlannerDefaults(acc) {
    setPlannerCredIds(function(prev) {
      var next = Object.assign({}, prev);
      var changed = false;
      Object.keys(acc).forEach(function(prov) {
        var ids = (acc[prov] || []).map(function(c) { return c.id; }).filter(Boolean);
        if (next[prov] && ids.indexOf(next[prov]) < 0) { delete next[prov]; changed = true; }
        if (!next[prov] && ids.length) { next[prov] = ids[0]; changed = true; }
      });
      if (!changed) return prev;
      try { window.localStorage.setItem('plannerCredentialIds', JSON.stringify(next)); } catch (e) {}
      return next;
    });
  }

  // Fetch accounts the first time the panel is opened.
  useEffect(function() {
    if (servicesOpen) loadAccounts();
  }, [servicesOpen]);

  // Persist the planner-default account choices so they survive reopening.
  function setPlannerDefault(provider, credentialId) {
    setPlannerCredIds(function(prev) {
      var next = Object.assign({}, prev);
      // Clicking the already-selected default clears it (back to "first account").
      if (next[provider] === credentialId) delete next[provider];
      else next[provider] = credentialId;
      try { window.localStorage.setItem('plannerCredentialIds', JSON.stringify(next)); } catch (e) {}
      return next;
    });
  }

  // Connect a provider from the panel. Unlike handleConnectClick (probe-driven,
  // queues an auto-retry), this is a plain up-front connect — open the OAuth
  // popup, then refresh the account list.
  function handleServiceConnect(provider) {
    if (serviceConnecting) return;
    setError('');
    setServiceConnecting(provider);
    connectProvider(provider)
      .then(function() { loadAccounts(); })
      .catch(function(err) {
        // Silent for user cancellation; surface real failures so a stuck
        // "Connecting" spinner can't hide a broken flow.
        var msg = err && err.message ? err.message : '';
        if (msg && msg !== 'cancelled' && msg !== 'superseded') setError(msg);
      })
      .then(function() { setServiceConnecting(null); });
  }

  // Disconnect a connected account, then refresh the list. Also clears the
  // planner default if it pointed at the removed credential.
  function handleServiceDisconnect(provider, credentialId) {
    if (!credentialId || removingId) return;
    setError('');
    setRemovingId(credentialId);
    request('/connected-accounts/' + encodeURIComponent(provider) + '/' + encodeURIComponent(credentialId), { method: 'DELETE' })
      .then(function() {
        setPlannerCredIds(function(prev) {
          if (prev[provider] !== credentialId) return prev;
          var next = Object.assign({}, prev);
          delete next[provider];
          try { window.localStorage.setItem('plannerCredentialIds', JSON.stringify(next)); } catch (e) {}
          return next;
        });
        loadAccounts();
      })
      .catch(function(err) {
        setError(err && err.message ? err.message : 'Failed to disconnect.');
      })
      .then(function() { setRemovingId(''); });
  }

  function sendMessage() {
    var text = input.trim();
    if (!text || loading || isBuilding) return;

    // When build is paused on a failing node, fix just that node (planner
    // conversation only — helper-mode text is never a node fix).
    if (!helperMode && buildPaused && failedNodeId && onFixNode) {
      setInput('');
      setLoading(true);
      setError('');
      setMessages(function(prev) { return prev.concat([{ role: 'user', content: text }]); });
      onFixNode(failedNodeId, text).then(function() {
        setLoading(false);
        setMessages(function(prev) { return prev.concat([{ role: 'assistant', content: 'Fix applied. Resuming build...' }]); });
        setBuildPaused(false);
        setBuildPhase('building');
        setFailedNodeId(null);
        var resume = buildResumeRef.current;
        buildResumeRef.current = null;
        if (resume) resume();
      }).catch(function(err) {
        setLoading(false);
        setError(err && err.message ? err.message : 'Fix failed. Please try again.');
      });
      return;
    }

    doSend(text);
  }

  function submitSelections(questions) {
    // Build a combined answer from all selections.
    // Most questions get "<question>: <answer>" so the assistant has context.
    // Memory consent (bareReply) sends just the answer so the server's
    // classifyMemoryConsentReply can detect leading-yes/no tokens.
    var answerParts = [];
    for (var i = 0; i < questions.length; i++) {
      var q = questions[i];
      // Multi-select answers arrive as an array — selectionText joins them.
      var answer = selectionText(selections[i]);
      if (answer) {
        answerParts.push(q.bareReply ? answer : (q.question + ': ' + answer));
      }
    }
    if (answerParts.length === 0) return;
    doSend(answerParts.join('\n'));
  }

  function onKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  // Pin the planner-default account onto every generated OAuth node, so the
  // built workflow runs against the same account the planner verified with.
  // We detect which provider a node uses by scanning its generationPrompt/code
  // for a bare `<provider>.login()` call (the only supported login form). Nodes
  // already carrying an explicit pin are left untouched. Mutates plan.nodes in
  // place (the plan is about to be consumed by the build).
  function pinPlannerAccountsOntoPlan(targetPlan) {
    if (!targetPlan || !Array.isArray(targetPlan.nodes)) return;
    var chosen = plannerCredIds || {};
    var providers = Object.keys(chosen).filter(function(p) { return chosen[p]; });
    if (providers.length === 0) return;
    targetPlan.nodes.forEach(function(node) {
      if (!node) return;
      var haystack = String(node.generationPrompt || '') + '\n' + String(node.code || '');
      var nextIds = Object.assign({}, node.credentialIds || {});
      var changed = false;
      providers.forEach(function(p) {
        // Don't override an explicit per-node pin the plan already set.
        if (nextIds[p]) return;
        var re = new RegExp('\\b' + p + '\\.login\\s*\\(', 'i');
        if (re.test(haystack)) { nextIds[p] = chosen[p]; changed = true; }
      });
      if (changed) node.credentialIds = nextIds;
    });
  }

  function startBuild(targetPlan) {
    var planToBuild = targetPlan || plan;
    if (!planToBuild) return;

    // Pin the chosen planner-default account(s) onto the OAuth nodes before build.
    pinPlannerAccountsOntoPlan(planToBuild);

    // For workflow format, minimize immediately so user sees nodes on canvas
    var isFullWorkflow = planToBuild.format === 'workflow';
    if (isFullWorkflow) {
      setMinimized(true);
    }

    setBuildStep(0);
    setBuildPhase('building');
    setBuildError('');
    setBuildDone(false);

    onBuildWorkflow(planToBuild, {
      onStepStart: function(stepIndex, phase) {
        setBuildStep(stepIndex);
        setBuildPhase(phase || 'building');
      },
      onStepDone: function(stepIndex) {
        setBuildStep(stepIndex + 1);
        setBuildPhase('building');
      },
      onDone: function() {
        setBuildDone(true);
        setTimeout(function() { onClose(); }, 1000);
      },
      onError: function(err) {
        setBuildError(err && err.message ? err.message : 'Build failed. Some nodes may be missing.');
        setBuildDone(false);
        setBuildStep(-1);
        setBuildPhase('');
        setBuildPaused(false);
        buildResumeRef.current = null;
        if (isFullWorkflow) setMinimized(false);
      },
      onRunError: function(errMsg, resume, nodeId) {
        setMinimized(false);
        setBuildPaused(true);
        setBuildPhase('');
        buildResumeRef.current = resume;
        setFailedNodeId(nodeId || null);
        setMessages(function(prev) {
          return prev.concat([{
            role: 'assistant',
            content: '\u26a0\ufe0f Build paused\n\n' + (errMsg || 'A node failed to execute.') + '\n\nPlease update required values in the Variables panel on the left, then click \u201cResume Build\u201d. If you want structural changes, send a new message here and I will update the plan.'
          }]);
        });
      }
    });
  }

  var steps = plan ? (plan.steps || plan.nodes || []) : [];
  var totalSteps = steps.length;
  // The chat surface shows whichever conversation the toggle selects.
  var activeMessages = helperMode ? helperMessages : messages;
  // The helper introduces itself under its own name, never "AI Assistant".
  var aiSenderLabel = helperMode ? 'Helper' : 'AI Assistant';
  // Fresh helper conversation → hero empty state instead of chat bubbles.
  var helperConvoEmpty = helperMode && activeMessages.filter(function(m) { return !m.local; }).length === 0;

  function renderHelperHero() {
    return h('div', { className: 'planner-helper-hero' },
      h('div', { className: 'planner-helper-hero-eyebrow' }, 'Guided setup'),
      h('div', { className: 'planner-helper-hero-title' }, 'What would you like to automate?'),
      h('div', { className: 'planner-helper-hero-sub' },
        'Start with a few words, then keep asking questions and refining ideas for as long as you need.'),
      h('div', { className: 'planner-helper-hero-label' }, 'Start from an example'),
      h('div', { className: 'planner-helper-hero-examples' },
        HELPER_EXAMPLES.map(function(ex) {
          return h('button', {
            key: ex,
            type: 'button',
            className: 'planner-helper-example-chip',
            onClick: function() { doSendHelper(translateText(ex)); }
          }, ex);
        })
      )
    );
  }
  // Helper-mode workflow suggestions render in the RIGHT (preview) panel, not
  // inline in the chat. Latest suggestion set wins; a generated plan replaces it.
  var helperSuggestions = [];
  for (var smi = activeMessages.length - 1; smi >= 0; smi--) {
    var sm = activeMessages[smi];
    if (sm.role === 'assistant' && Array.isArray(sm.suggestions) && sm.suggestions.length > 0) {
      helperSuggestions = sm.suggestions;
      break;
    }
  }
  var canEditConversation = !loading && !isBuilding;
  var canTypeWhileStreaming = !isBuilding;

  function stopStream() {
    if (abortStreamRef.current) {
      try { abortStreamRef.current(); } catch (e) {}
      abortStreamRef.current = null;
    }
    setLoading(false);
    buildAfterGenerationRef.current = false;
    setGeneratingWorkflow(false);
    setProbing(false);
    setProbeLabels([]);
    var captured = streamingText;
    setStreamingText('');
    setThinkingStatus('');
    setProbeEvents([]);
    var clean = stripStreamingXml(captured || '').trim();
    if (clean) {
      var appendStopped = function(prev) {
        return prev.concat([{ role: 'assistant', content: clean, displayContent: clean + '\n\n_(stopped)_' }]);
      };
      if (helperMode) setHelperMessages(appendStopped);
      else setMessages(appendStopped);
    }
  }

  var buildStatusText = '';
  if (isBuilding && buildStep >= 0 && buildStep < totalSteps) {
    var phaseWord = buildPhase === 'running' ? 'Running' : 'Building';
    buildStatusText = phaseWord + ' step ' + (buildStep + 1) + ' of ' + totalSteps + '…';
  }

  // ── Render AI message with interactive options ──────────────────────────────
  function renderAiMessage(msg, idx, isLast) {
    var parsed = parseAiMessage(msg.displayContent || msg.content);
    var questions = parsed.parts.filter(function(p) { return p.type === 'question' || p.type === 'input'; });
    var hasQuestions = questions.length > 0;
    var interactive = isLast && hasQuestions && !loading && !isBuilding;

    var qIdx = 0;
    var elements = [];

    // Skip / Next / Submit footer props — rendered by QuestionTabs (with the
    // group holding the LAST question) so Submit only shows on the final tab.
    var footerProps = null;
    if (interactive) {
      var answeredCount = Object.keys(selections).filter(function(k) { return selections[k] && String(selections[k]).trim(); }).length;
      footerProps = {
        answered: answeredCount,
        total: questions.length,
        onSkip: function() { doSend('Skip — proceed with your best judgment.'); },
        onSubmit: function() { submitSelections(questions); }
      };
    }

    // Consecutive question parts collapse into ONE tabbed control (QuestionTabs)
    // instead of a long stacked scroll; a run of one renders as a plain block.
    var pendingQuestions = [];
    function flushQuestions() {
      if (pendingQuestions.length === 0) return;
      elements.push(h(QuestionTabs, {
        key: 'qgrp-' + pendingQuestions[0].key,
        items: pendingQuestions,
        // Only the run ending at the message's last question carries the footer.
        footer: qIdx === questions.length ? footerProps : null
      }));
      pendingQuestions = [];
    }

    parsed.parts.forEach(function(part, pIdx) {
      if (part.type === 'text') {
        // Connector prose between questions ("And one more:") renders, but
        // must NOT flush the run — flushing here split the tabbed control
        // into stacked single-question blocks with no tab bar.
        if (!hasQuestionPartAfter(parsed.parts, pIdx)) flushQuestions();
        elements.push(
          h('div', { key: 'txt-' + pIdx, className: 'planner-message-text' }, formatText(part.text))
        );
      } else if (part.type === 'question' || part.type === 'input') {
        // Shared card-style Q&A control (label + description rows, number
        // badges, Other free-text) — same component the AI Flow balloon uses.
        var capturedQIdx = qIdx++;
        pendingQuestions.push({ key: 'q-' + pIdx, props: {
          part: part,
          interactive: interactive,
          selected: selections[capturedQIdx] || '',
          onSelect: (function(qi) {
            return function(value) {
              var copy = Object.assign({}, selections);
              if (value && String(value).trim()) copy[qi] = value; else delete copy[qi];
              setSelections(copy);
            };
          })(capturedQIdx),
          otherOpen: otherOpen === capturedQIdx,
          otherText: otherOpen === capturedQIdx ? otherText : '',
          onOtherToggle: (function(qi) {
            return function(open, seed) {
              setOtherOpen(open ? qi : null);
              setOtherText(open ? (seed || '') : '');
            };
          })(capturedQIdx),
          onOtherText: setOtherText
        } });
      } else if (part.type === 'plan_preview') {
        flushQuestions();
        // Pre-generation review: one action generates the concrete plan and
        // continues directly into the existing canvas builder.
        // Only the LAST AI message gets an active button — older previews render static.
        var canGenerate = isLast && !loading && !isBuilding;
        elements.push(
          h('div', { key: 'pp-' + pIdx, className: 'planner-plan-preview' },
            h('div', { className: 'planner-plan-preview-header' }, 'Workflow plan'),
            part.summary && part.summary.length > 0
              ? h('div', { className: 'planner-plan-preview-section' },
                  h('div', { className: 'planner-plan-preview-label' }, 'Steps'),
                  h('ol', { className: 'planner-plan-preview-steps' },
                    part.summary.map(function(step, sIdx) {
                      return h('li', { key: sIdx }, formatText(step));
                    })
                  )
                )
              : null,
            part.positive
              ? h('div', { className: 'planner-plan-preview-section' },
                  h('div', { className: 'planner-plan-preview-label planner-plan-preview-label-positive' }, 'When everything works'),
                  h('div', { className: 'planner-plan-preview-text' }, formatText(part.positive))
                )
              : null,
            part.negative
              ? h('div', { className: 'planner-plan-preview-section' },
                  h('div', { className: 'planner-plan-preview-label planner-plan-preview-label-negative' }, 'When something goes wrong'),
                  h('div', { className: 'planner-plan-preview-text' }, formatText(part.negative))
                )
              : null,
            canGenerate
              ? h('div', { className: 'planner-plan-preview-actions' },
                  h('button', {
                    className: 'planner-plan-preview-generate-btn',
                    onClick: function() {
                      buildAfterGenerationRef.current = true;
                      doSendPlanner('Generate the workflow now.');
                    }
                  }, 'Build this workflow',
                    h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                      h('polyline', { points: '9 18 15 12 9 6' })
                    )
                  )
                )
              : null
          )
        );
      }
    });
    flushQuestions();

    // Workflow suggestions (helper mode finale) render in the RIGHT preview
    // panel, not inline — the chat only gets a short pointer to them.
    if (msg.suggestions && msg.suggestions.length > 0) {
      elements.push(
        h('div', { key: 'suggestions', className: 'planner-suggestions-pointer' },
          h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
            h('line', { x1: 5, y1: 12, x2: 19, y2: 12 }),
            h('polyline', { points: '12 5 19 12 12 19' })
          ),
          msg.suggestions.length,
          ' ',
          msg.suggestions.length !== 1 ? 'workflow suggestions' : 'workflow suggestion',
          ' ready — pick one in the panel on the right.'
        )
      );
    }

    return h('div', { key: idx, className: 'planner-message planner-message-ai' },
      h('div', { className: 'planner-message-content' },
        h('div', { className: 'planner-message-sender' }, aiSenderLabel),
        h('div', { className: 'planner-message-bubble' }, elements)
      ),
      h('div', { className: 'planner-message-actions' },
        h('button', {
          className: 'planner-msg-action-btn',
          title: 'Copy',
          onClick: function() {
            var text = msg.displayContent || msg.content;
            if (navigator.clipboard) navigator.clipboard.writeText(text);
          }
        },
          h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
            h('rect', { x: 9, y: 9, width: 13, height: 13, rx: 2, ry: 2 }),
            h('path', { d: 'M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1' })
          )
        ),
        h('button', {
          className: 'planner-msg-action-btn',
          title: 'Edit',
          onClick: function() {
            setInput(msg.displayContent || msg.content);
            if (inputRef.current) inputRef.current.focus();
          }
        },
          h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
            h('path', { d: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7' }),
            h('path', { d: 'M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z' })
          )
        )
      )
    );
  }

  // ── MINIMIZED PILL ──────────────────────────────────────────────────────────
  if (minimized) {
    var pill = h('button', {
      className: 'planner-pill',
      type: 'button',
      onMouseDown: function(e) { e.preventDefault(); e.stopPropagation(); },
      onClick: function(e) { e.preventDefault(); e.stopPropagation(); setMinimized(false); },
      title: 'Restore planner'
    },
      isBuilding
        ? h('span', { className: 'planner-pill-spinner' })
        : h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
            h('path', { d: 'M12 2L2 7l10 5 10-5-10-5z' }),
            h('path', { d: 'M2 17l10 5 10-5' }),
            h('path', { d: 'M2 12l10 5 10-5' })
          ),
      h('span', { className: 'planner-pill-label' },
        buildDone ? 'Done!' : buildPaused ? '⚠ Paused — click to resume' : isBuilding ? buildStatusText : (plan ? 'Plan ready' : 'Plan a Workflow')
      ),
      h('span', { className: 'planner-pill-restore' },
        h('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
          h('polyline', { points: '15 3 21 3 21 9' }),
          h('polyline', { points: '9 21 3 21 3 15' }),
          h('line', { x1: 21, y1: 3, x2: 14, y2: 10 }),
          h('line', { x1: 3, y1: 21, x2: 10, y2: 14 })
        )
      )
    );
    if (typeof document !== 'undefined' && document.body && ReactDOM && typeof ReactDOM.createPortal === 'function') {
      return ReactDOM.createPortal(pill, document.body);
    }
    return pill;
  }

  // ── SERVICES LINK + PANEL ──────────────────────────────────────────────────
  // Connect / manage service accounts — a clickable link that expands an
  // inline panel (no native overlay, per the no-popups rule) with a Connect
  // button per OAuth provider. Both modes use the helper's layout: the link
  // sits bottom-left in the input toolbar and the panel opens below it.
  var servicesLink = h('button', {
    type: 'button',
    className: 'planner-services-link',
    onClick: function() { setServicesOpen(function(v) { return !v; }); }
  },
    h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      h('rect', { x: 4, y: 4, width: 16, height: 16, rx: 3 })
    ),
    'Connected accounts'
  );
  var servicesPanel = servicesOpen
    ? h('div', { className: 'planner-services-panel' },
        h('div', { className: 'planner-services-hint' },
          'Pick which account the planner uses to verify & build. ',
          h('span', { className: 'planner-services-hint-muted' }, 'No selection uses your first connected account.')),
        // A probe is blocked on a missing connection — offer a retry
        // for users who connected on the Accounts page / another tab.
        connectNeeded
          ? h('div', { style: { display: 'flex', alignItems: 'center', gap: '10px', margin: '4px 0 10px', padding: '10px 12px', border: '1px solid #2f7d4f', borderRadius: '8px', fontSize: '13px' } },
              h('span', null, connectNeededLabel(connectNeeded) + ' isn’t connected yet.'),
              h('button', {
                type: 'button',
                onClick: handleAlreadyConnectedRetry,
                disabled: !!pendingRetry,
                style: { marginLeft: 'auto', padding: '6px 12px', borderRadius: '6px', border: 'none', background: pendingRetry ? '#9bbfa9' : '#2f7d4f', color: '#fff', fontSize: '13px', cursor: pendingRetry ? 'default' : 'pointer', whiteSpace: 'nowrap' }
              }, pendingRetry ? 'Retrying…' : 'Already connected — retry')
            )
          : null,
        Object.keys(PROVIDER_LABELS).map(function(prov) {
          var connecting = serviceConnecting === prov;
          var list = accounts[prov] || [];
          var chosen = plannerCredIds[prov] || '';
          return h('div', { key: prov, className: 'planner-services-card' },
            h('div', { className: 'planner-services-card-head' },
              h('span', { className: 'planner-services-logo-chip' },
                h(ProviderLogo, { provider: prov })
              ),
              h('span', { className: 'planner-services-card-title' },
                PROVIDER_LABELS[prov],
                h('span', { className: 'planner-services-count' + (list.length ? '' : ' planner-services-count-empty') },
                  list.length ? (list.length + ' connected') : 'Not connected')
              ),
              h('button', {
                type: 'button',
                className: 'planner-services-connect-btn',
                disabled: !!serviceConnecting,
                onClick: function() { handleServiceConnect(prov); }
              },
                connecting
                  ? h('span', { className: 'planner-services-btn-spinner' })
                  : h('svg', { width: 13, height: 13, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.2 },
                      h('line', { x1: 12, y1: 5, x2: 12, y2: 19 }),
                      h('line', { x1: 5, y1: 12, x2: 19, y2: 12 })
                    ),
                connecting ? 'Connecting' : (list.length ? 'Add account' : 'Connect')
              )
            ),
            list.length
              ? h('div', { className: 'planner-services-accounts' },
                  list.map(function(cred) {
                    var isDefault = chosen === cred.id;
                    var isRemoving = removingId === cred.id;
                    return h('div', { key: cred.id || accountDisplayName(prov, cred), className: 'planner-services-account' + (isDefault ? ' planner-services-account-on' : '') },
                      h('button', {
                        type: 'button',
                        className: 'planner-services-pick',
                        disabled: !cred.id,
                        title: isDefault ? 'Default for the planner — click to clear' : 'Use this account for the planner',
                        onClick: function() { setPlannerDefault(prov, cred.id); }
                      },
                        h('span', { className: 'planner-services-radio' + (isDefault ? ' planner-services-radio-on' : '') },
                          isDefault
                            ? h('svg', { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 3 },
                                h('polyline', { points: '20 6 9 17 4 12' })
                              )
                            : null
                        ),
                        h('span', { className: 'planner-services-account-name' }, accountDisplayName(prov, cred)),
                        isDefault ? h('span', { className: 'planner-services-default-tag' }, 'Default') : null
                      ),
                      h('button', {
                        type: 'button',
                        className: 'planner-services-disconnect-btn',
                        disabled: !cred.id || isRemoving,
                        title: 'Disconnect this account',
                        onClick: function() { handleServiceDisconnect(prov, cred.id); }
                      }, isRemoving ? 'Removing…' : 'Disconnect')
                    );
                  })
                )
              : null
          );
        })
      )
    : null;

  // ── SUGGESTION CARDS ────────────────────────────────────────────────────────
  // Render tailored suggestions after the helper has enough information.
  function renderSuggestionsPanel(list, eyebrow, subText) {
    var canPick = !loading && !isBuilding;
    return h('div', { className: 'planner-preview-suggestions' },
      h('div', { className: 'planner-preview-suggestions-header' },
        h('span', { className: 'planner-preview-suggestions-heading' }, 'Suggested workflows'),
        h('span', { className: 'planner-preview-suggestions-eyebrow' },
          h('span', { className: 'planner-preview-suggestions-dot' }),
          eyebrow
        )
      ),
      h('div', { className: 'planner-preview-suggestions-sub' }, subText),
      h('div', { className: 'planner-preview-suggestions-grid' },
        list.map(function(sug, si) {
          return h('button', {
            key: 'sug-' + si,
            className: 'planner-suggestion-card',
            disabled: !canPick,
            title: canPick ? 'Build this workflow' : '',
            onClick: function() { handleSuggestionSelect(sug); }
          },
            h('span', { className: 'planner-suggestion-icon' },
              h('svg', { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.7 },
                h('rect', { x: 3, y: 3, width: 8, height: 8, rx: 2 }),
                h('rect', { x: 13, y: 13, width: 8, height: 8, rx: 2 }),
                h('path', { d: 'M11 7h3a3 3 0 0 1 3 3v3' })
              )
            ),
            h('div', { className: 'planner-suggestion-main' },
              h('div', { className: 'planner-suggestion-title' }, sug.title),
              sug.description ? h('div', { className: 'planner-suggestion-desc' }, sug.description) : null
            ),
            sug.tag ? h('span', { className: 'planner-suggestion-tag' }, sug.tag) : null
          );
        })
      )
    );
  }

  // ── FULL MODAL ──────────────────────────────────────────────────────────────
  return h('div', {
    className: 'planner-overlay',
    onMouseDown: function(e) {
      e.stopPropagation();
      if (e.target === e.currentTarget && !isBuilding) onClose();
    },
    onTouchStart: function(e) { e.stopPropagation(); },
    onWheel: function(e) { e.stopPropagation(); },
    onTouchMove: function(e) { e.stopPropagation(); }
  },
    h('div', {
      // Helper mode gets its own visual identity (purple accents) so users
      // always know whether they're talking to the Helper or the planner.
      className: 'planner-modal' + (helperMode ? ' planner-modal-helper' : ''),
      onMouseDown: function(e) { e.stopPropagation(); },
      onTouchStart: function(e) { e.stopPropagation(); },
      onWheel: function(e) { e.stopPropagation(); },
      onTouchMove: function(e) { e.stopPropagation(); }
    },
      // Header
      h('div', { className: 'planner-header' },
        h('div', { className: 'planner-header-left' },
          helperMode
            ? h('span', { className: 'planner-helper-title-icon' },
                h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                  h('rect', { x: 4, y: 9, width: 16, height: 11, rx: 2.5 }),
                  h('path', { d: 'M12 5v4' }),
                  h('circle', { cx: 12, cy: 4, r: 1, fill: 'currentColor', stroke: 'none' }),
                  h('circle', { cx: 9.5, cy: 14, r: 1.1, fill: 'currentColor', stroke: 'none' }),
                  h('circle', { cx: 14.5, cy: 14, r: 1.1, fill: 'currentColor', stroke: 'none' })
                )
              )
            : null,
          h('div', { className: 'planner-title' }, helperMode ? 'Automate a task' : 'Workflow planner'),
          h('span', { className: 'planner-badge' }, helperMode ? 'Guided' : 'Advanced')
        ),
        h('div', { className: 'planner-header-actions' },
          h('button', {
            className: 'planner-minimize-btn',
            onClick: function() { setMinimized(true); },
            title: 'Minimize'
          },
            h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
              h('line', { x1: 5, y1: 12, x2: 19, y2: 12 })
            )
          ),
          !isBuilding
            ? h('button', {
                className: 'planner-close-btn',
                onClick: onClose,
                title: 'Close'
              },
                h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                  h('line', { x1: 18, y1: 6, x2: 6, y2: 18 }),
                  h('line', { x1: 6, y1: 6, x2: 18, y2: 18 })
                )
              )
            : null
        )
      ),

      // Body
      h('div', { className: 'planner-body' + (plan ? ' planner-body-with-plan' : '') },

        // Chat area
        h('div', { className: 'planner-chat' },
          h('div', { className: 'planner-messages' },
            helperConvoEmpty ? renderHelperHero() : activeMessages.map(function(msg, idx) {
              var isUser = msg.role === 'user';
              var isLast = idx === activeMessages.length - 1;

              if (!isUser) {
                return renderAiMessage(msg, idx, isLast);
              }

              return h('div', {
                key: idx,
                className: 'planner-message planner-message-user'
              },
                h('div', { className: 'planner-message-actions' },
                  h('button', {
                    className: 'planner-msg-action-btn',
                    title: 'Copy',
                    onClick: function() {
                      if (navigator.clipboard) navigator.clipboard.writeText(msg.content);
                    }
                  },
                    h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                      h('rect', { x: 9, y: 9, width: 13, height: 13, rx: 2, ry: 2 }),
                      h('path', { d: 'M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1' })
                    )
                  ),
                  h('button', {
                    className: 'planner-msg-action-btn',
                    title: 'Edit',
                    onClick: function() {
                      setInput(msg.content);
                      if (inputRef.current) inputRef.current.focus();
                    }
                  },
                    h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                      h('path', { d: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7' }),
                      h('path', { d: 'M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z' })
                    )
                  )
                ),
                h('div', { className: 'planner-message-bubble' }, msg.content)
              );
            }),
            // Streaming AI response
            loading && streamingText
              ? (function() {
                  var cleanText = stripStreamingXml(streamingText);
                  if (!cleanText) return null;
                  return h('div', { className: 'planner-message planner-message-ai' },
                    h('div', { className: 'planner-message-content' },
                      h('div', { className: 'planner-message-sender' }, aiSenderLabel),
                      h('div', { className: 'planner-message-bubble planner-message-streaming' },
                        formatText(cleanText),
                        h('span', { className: 'planner-stream-cursor' })
                      )
                    )
                  );
                })()
              : null,

            // Reused nodes from node-memory — overlapping logo avatars.
            similarNodesUsed.length > 0
              ? h('div', { className: 'planner-similar-nodes', style: { display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' } },
                  h('div', { style: { display: 'flex' } },
                    similarNodesUsed.slice(0, 5).map(function(sn, snIdx) {
                      return h('div', {
                        key: snIdx,
                        title: sn.title + ' (' + Math.round((sn.score || 0) * 100) + '% match)',
                        style: { width: '26px', height: '26px', borderRadius: '50%', overflow: 'hidden', background: '#fff', border: '2px solid #fff', boxShadow: '0 0 0 1px #d8dee4', marginLeft: snIdx === 0 ? '0' : '-8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }
                      },
                        sn.logoUrl
                          ? h('img', { src: sn.logoUrl, alt: sn.title, style: { width: '100%', height: '100%', objectFit: 'cover' }, onError: function(e) { e.target.style.display = 'none'; } })
                          : h(NodeIcon, { type: sn.icon || 'custom', size: 15 })
                      );
                    })
                  ),
                  h('span', { style: { fontSize: '12px', color: '#57606a' } },
                    'Reusing ' + similarNodesUsed.length + ' of your existing node' + (similarNodesUsed.length > 1 ? 's' : ''))
                )
              : null,

            // Probe events
            loading && probeEvents.length > 0
              ? h('div', { className: 'planner-probe-events' },
                  probeEvents.map(function(pe, peIdx) {
                    var statusIcon = pe.status === 'running' ? '\u23f3'
                      : pe.status === 'ok' ? '\u2705' : '\u274c';
                    return h('div', { key: peIdx, className: 'planner-probe-event planner-probe-' + pe.status },
                      h('span', { className: 'planner-probe-event-icon' }, statusIcon),
                      h('span', { className: 'planner-probe-event-label' }, pe.label),
                      pe.status === 'running'
                        ? h('span', { className: 'planner-probe-event-spinner' })
                        : null,
                      pe.output && pe.status !== 'running'
                        ? h('div', { className: 'planner-probe-event-output' }, pe.output)
                        : null
                    );
                  })
                )
              : null,

            // Connect-account prompt — shown when a probe failed only because a
            // login() service isn't connected. Persists past the turn so the user
            // can connect; on success the planner auto-retries. The "already
            // connected — retry" button covers connections made outside this
            // modal (Accounts page, another tab).
            connectNeeded
              ? h('div', { className: 'planner-connect-prompt', style: { margin: '10px 0', padding: '12px 14px', border: '1px solid #d8dee4', borderLeft: '3px solid #2f7d4f', borderRadius: '8px', background: '#f6f8fa' } },
                  h('div', { style: { marginBottom: '8px', fontSize: '13px', color: '#24292f' } },
                    'Connect your ' + connectNeededLabel(connectNeeded) + ' account to continue — then I’ll re-check and keep going.'),
                  h('button', {
                    onClick: function() { handleConnectClick(connectNeeded); },
                    disabled: !!pendingRetry,
                    style: { padding: '7px 14px', borderRadius: '6px', border: 'none', background: pendingRetry ? '#9bbfa9' : '#2f7d4f', color: '#fff', fontSize: '13px', cursor: pendingRetry ? 'default' : 'pointer', marginRight: '8px' }
                  }, pendingRetry ? 'Connecting…' : ('Connect ' + connectNeededLabel(connectNeeded))),
                  h('button', {
                    onClick: handleAlreadyConnectedRetry,
                    disabled: !!pendingRetry,
                    style: { padding: '7px 14px', borderRadius: '6px', border: '1px solid #2f7d4f', background: 'transparent', color: pendingRetry ? '#9bbfa9' : '#2f7d4f', fontSize: '13px', cursor: pendingRetry ? 'default' : 'pointer' }
                  }, pendingRetry ? 'Retrying…' : 'Already connected — retry')
                )
              : null,

            // Thinking status (when no streaming text and no probes)
            loading && !streamingText && probeEvents.length === 0
              ? h('div', { className: 'planner-message planner-message-ai' },
                  h('div', { className: 'planner-message-content' },
                    h('div', { className: 'planner-message-sender' }, aiSenderLabel),
                    h('div', { className: 'planner-message-bubble planner-message-typing' },
                      h('span', { className: 'planner-typing-dot' }),
                      h('span', { className: 'planner-typing-dot' }),
                      h('span', { className: 'planner-typing-dot' }),
                      thinkingStatus
                        ? h('span', { className: 'planner-thinking-label' }, thinkingStatus)
                        : null
                    )
                  )
                )
              : null,
            error ? h('div', { className: 'planner-chat-error' }, error) : null,
            h('div', { ref: messagesEndRef })
          ),

          // Token usage
          tokenUsage
            ? h('div', { className: 'planner-token-usage' },
                h('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, className: 'planner-token-icon' },
                  h('circle', { cx: 12, cy: 12, r: 10 }),
                  h('path', { d: 'M12 6v6l4 2' })
                ),
                (function() {
                  var parts = [];
                  var p = tokenUsage.planning;
                  var pr = tokenUsage.probing;
                  var g = tokenUsage.generating;
                  if (p && (p.input + p.output) > 0) {
                    parts.push(h('span', { key: 'p', className: 'planner-token-phase' },
                      h('span', { className: 'planner-token-label' }, 'Planning'),
                      h('span', { className: 'planner-token-value' }, formatTokenCount(p.input + p.output))
                    ));
                  }
                  if (pr && (pr.input + pr.output) > 0) {
                    parts.push(h('span', { key: 'pr', className: 'planner-token-phase' },
                      h('span', { className: 'planner-token-label' }, 'Probing'),
                      h('span', { className: 'planner-token-value' }, formatTokenCount(pr.input + pr.output))
                    ));
                  }
                  if (g && (g.input + g.output) > 0) {
                    parts.push(h('span', { key: 'g', className: 'planner-token-phase' },
                      h('span', { className: 'planner-token-label' }, 'Generating'),
                      h('span', { className: 'planner-token-value' }, formatTokenCount(g.input + g.output))
                    ));
                  }
                  var total = (p ? p.input + p.output : 0) + (pr ? pr.input + pr.output : 0) + (g ? g.input + g.output : 0);
                  parts.push(h('span', { key: 't', className: 'planner-token-phase planner-token-total' },
                    h('span', { className: 'planner-token-label' }, 'Total'),
                    h('span', { className: 'planner-token-value' }, formatTokenCount(total))
                  ));
                  return parts;
                })()
              )
            : null,

          // Input container
          h('div', { className: 'planner-input-container' },
            plan && !helperMode
              ? h('div', { className: 'planner-input-hint' }, 'Ask for changes to existing variables or nodes before building.')
              : null,

            h('div', { className: 'planner-input-row' },
              h('span', { className: 'planner-input-sparkle' },
                h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                  h('path', { d: 'M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z' })
                )
              ),
              h('textarea', {
                ref: inputRef,
                className: 'planner-input',
                // Same invitation in both modes — a described task OR a plain
                // "here's my day" ramble is a fine way to start. Only the
                // planner's follow-up turns (a plan already exists) differ.
                placeholder: !helperMode && plan
                  ? 'Request plan changes...'
                  : 'Describe the task, or just tell me about your day…',
                value: input,
                onChange: function(e) { setInput(e.target.value); },
                onKeyDown: onKeyDown,
                disabled: !canTypeWhileStreaming,
                rows: 2,
                spellCheck: false
              })
            ),
            h('div', { className: 'planner-input-toolbar' },
              // Accounts link sits bottom-left in the input card; the
              // expandable panel renders below the toolbar.
              servicesLink,
              // "Suggest a workflow" toggle — the planner is the default; this
              // switches to the Workflow Helper, a guided Q&A for users who
              // can't describe what to automate yet. Kept visible here (rather
              // than inside Advanced) so it's discoverable.
              h('button', {
                className: 'planner-helper-toggle' + (helperMode ? ' planner-helper-toggle-on' : ''),
                onClick: toggleHelperMode,
                disabled: loading || isBuilding,
                title: helperMode
                  ? 'Suggest a workflow is ON — I ask simple questions and suggest workflows you can pick. Click to switch back to the planner.'
                  : 'Not sure what to build? Turn this on and I’ll ask simple questions, then suggest workflows you can pick.'
              },
                h('span', { className: 'planner-helper-toggle-track' },
                  h('span', { className: 'planner-helper-toggle-knob' })
                ),
                'Suggest a workflow'
              ),
              // Planner-only (the helper always runs the lightweight model).
              helperMode ? null : h('button', {
                className: 'planner-advanced-toggle' + (advancedOpen ? ' planner-advanced-toggle-on' : ''),
                onClick: function() { setAdvancedOpen(function(open) { return !open; }); },
                disabled: loading || isBuilding,
                title: 'Show advanced planning options',
                'aria-expanded': advancedOpen
              },
                'Advanced',
                h('span', { className: 'planner-advanced-chevron' }, advancedOpen ? '−' : '+')
              ),
              loading
                ? h('button', {
                    className: 'planner-send-btn planner-send-btn-stop',
                    onClick: stopStream,
                    title: 'Stop (interrupts the AI so you can chat)'
                  },
                    h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'currentColor' },
                      h('rect', { x: 5, y: 5, width: 14, height: 14, rx: 2 })
                    )
                  )
                : h('button', {
                    className: 'planner-send-btn',
                    onClick: sendMessage,
                    disabled: !input.trim() || !canEditConversation,
                    title: 'Send (Enter)'
                  },
                    h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                      h('polyline', { points: '5 12 12 5 19 12' }),
                      h('line', { x1: 12, y1: 5, x2: 12, y2: 19 })
                    )
                  )
            ),
            servicesOpen
              ? h('div', { className: 'planner-services planner-services-inline' }, servicesPanel)
              : null,
            // Advanced holds planner-only settings; the helper always runs the
            // lightweight model, so it has nothing to show there.
            advancedOpen && !helperMode
              ? h('div', { className: 'planner-advanced-panel' },
                  h('div', { className: 'planner-advanced-row' },
                    h('span', { className: 'planner-advanced-label' }, 'Model quality'),
                    h('button', {
                      className: 'planner-mode-toggle planner-mode-' + plannerMode,
                      onClick: togglePlannerMode,
                      disabled: loading,
                      title: PLANNER_MODE_TITLES[plannerMode]
                    },
                      h('span', { className: 'planner-mode-dot' }),
                      PLANNER_MODE_LABELS[plannerMode]
                    )
                  )
                )
              : null
          )
        ),

        // Right panel — preview / plan
        h('div', { className: 'planner-preview-panel' },
          // Plan steps (when plan exists)
          plan
            ? h('div', { className: 'planner-plan-section' },
                h('div', { className: 'planner-plan-header' },
                  h('div', { className: 'planner-plan-title' }, plan.title || 'Workflow Plan'),
                  h('div', { className: 'planner-plan-count' }, totalSteps + ' step' + (totalSteps !== 1 ? 's' : ''))
                ),
                h('div', { className: 'planner-plan-steps' },
                  steps.map(function(step, idx) {
                    var isBuildingStep = buildStep === idx;
                    var isDoneStep = buildStep > idx || buildDone;
                    return h(PlanStepItem, {
                      key: idx,
                      step: step,
                      index: idx,
                      isBuilding: isBuildingStep,
                      isDone: isDoneStep,
                      phase: isBuildingStep ? buildPhase : ''
                    });
                  })
                ),
                buildError ? h('div', { className: 'planner-build-error' }, buildError) : null,
                buildDone
                  ? h('div', { className: 'planner-build-success' }, 'Workflow built successfully!')
                  : buildPaused
                    ? h('button', {
                        className: 'planner-resume-btn',
                        onClick: function() {
                          setBuildPaused(false);
                          setBuildPhase('building');
                          var resume = buildResumeRef.current;
                          buildResumeRef.current = null;
                          if (resume) {
                            resume();
                            return;
                          }
                          if (plan) {
                            startBuild();
                          }
                        }
                      },
                        h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                          h('polygon', { points: '5 3 19 12 5 21 5 3' })
                        ),
                        'Resume Build'
                      )
                    : !isBuilding
                      ? h('button', { className: 'planner-build-btn', onClick: function() { startBuild(); } },
                          h('svg', { width: 15, height: 15, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                            h('polygon', { points: '5 3 19 12 5 21 5 3' })
                          ),
                          'Build this workflow'
                        )
                      : h('div', { className: 'planner-building-status' },
                          h('span', { className: 'planner-build-spinner' }),
                          buildStatusText
                        )
              )
            : null,

          // Generating workflow animation (full panel)
          !plan && generatingWorkflow
            ? h('div', { className: 'planner-preview-generating' },
                h('div', { className: 'planner-preview-coding-header' },
                  h('span', { className: 'planner-send-spinner' }),
                  h('span', null, thinkingStatus || 'Preparing your workflow...'),
                  streamingText
                    ? h('span', { className: 'planner-preview-char-count' }, streamingText.length.toLocaleString() + ' chars')
                    : null
                ),
                h(CodingLines, null)
              )
            : null,

          // Helper-mode workflow suggestions — selectable cards in the preview
          // panel. Picking one leaves helper mode and auto-pilots the planner.
          !plan && !generatingWorkflow && helperSuggestions.length > 0
            ? renderSuggestionsPanel(
                helperSuggestions,
                'Best matches',
                'Based on what you told me. Pick one and I’ll build it.'
              )
            : null,

          // Empty state until the helper returns suggestions or the planner
          // produces a workflow plan.
          !plan && !generatingWorkflow && helperSuggestions.length === 0
            ? h('div', { className: 'planner-preview-empty' },
                h('div', { className: 'planner-preview-empty-icon' },
                  h('svg', { width: 48, height: 48, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.2 },
                    h('path', { d: 'M12 2L2 7l10 5 10-5-10-5z' }),
                    h('path', { d: 'M2 17l10 5 10-5' }),
                    h('path', { d: 'M2 12l10 5 10-5' })
                  )
                ),
                h('div', { className: 'planner-preview-empty-title' }, helperMode ? 'Suggested workflows' : 'Flow Preview'),
                h('div', { className: 'planner-preview-empty-desc' }, helperMode
                  ? 'Your tailored workflow suggestions will appear here.'
                  : 'Your workflow will appear here once the plan is ready.')
              )
            : null
        )
      )
    )
  );
}

module.exports = WorkflowPlannerModal;
